import type { CityConfig } from "../city-template/types";

export const lynchburgVaConfig: CityConfig = {
  city: "Lynchburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "lynchburg-va",
  route: "/lynchburg-va",
  title: "Emergency Passport Lynchburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lynchburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Lynchburg, Campbell County, and the Central Virginia Piedmont. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Lynchburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Campbell County, Amherst County, or the Central Virginia Piedmont? We help Lynchburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lynchburg%20Virginia%20downtown%20with%20the%20historic%20Point%20of%20Honor%20mansion%20on%20the%20James%20River%2C%20modern%20city%20skyline%20with%20historic%20buildings%20and%20the%20Blackwater%20Creek%20trails%2C%20the%20Liberty%20University%20campus%20visible%20in%20the%20background%2C%20warm%20afternoon%20light%20with%20rolling%20Piedmont%20hills%20and%20blue%20ridges%2C%20professional%20photography%20showcasing%20Central%20Virginia%20small%20city%20with%20historic%20charm%20and%20modern%20development%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20riverfront%20park%20and%20Appalachian%20foothills%20backdrop&width=1800&height=700&seq=lynchburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Lynchburg Virginia downtown with historic Point of Honor mansion on the James River and Liberty University campus",
  geoPosition: "37.4138;-79.1422",
  geoPlacename: "Lynchburg, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles northeast of Lynchburg via I-81 and I-66",
  },
  nearbyCitiesZips: [
    { name: "Lynchburg", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24514, 24515" },
    { name: "Campbell County", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24514, 24515" },
    { name: "Amherst", zips: "24521" },
    { name: "Appomattox", zips: "24522" },
    { name: "Bedford", zips: "24523" },
    { name: "Altavista", zips: "24517" },
    { name: "Madison Heights", zips: "24572" },
    { name: "Forest", zips: "24551" },
    { name: "Rustburg", zips: "24588" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Danville", zips: "24540, 24541, 24543, 24544" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Harrisonburg", zips: "22801, 22802, 22803, 22807" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Central Virginia Piedmont" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Central Virginia Piedmont Hub", desc: "Serving Lynchburg, Campbell County, Amherst, Bedford, and the Piedmont region" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Charlottesville VA passport services", route: "/charlottesville-va" },
    { name: "Roanoke VA passport services", route: "/roanoke-va" },
    { name: "Richmond VA passport services", route: "/richmond-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lynchburg remotely via secure courier. We do not have a walk-in office in Lynchburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Lynchburg and Central Virginia Piedmont travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Lynchburg and the Central Virginia Piedmont including Campbell County, Amherst County, Bedford County, Appomattox, Altavista, and the greater Lynchburg region",
  serviceAreaIntro: "From the historic downtown of Lynchburg to the rolling hills of the Piedmont, from the Liberty University campus to the shores of Smith Mountain Lake, from the quaint towns of Appomattox and Bedford to the growing communities of Forest and Madison Heights — Fast Passport Center serves every corner of Lynchburg and the Central Virginia Piedmont. We regularly help travelers from Amherst, Bedford, Appomattox, and Charlottesville get their passports fast.",
  nearbyCitiesIntro: "We serve all Lynchburg neighborhoods and the Central Virginia Piedmont including Campbell County, Amherst, Bedford, Appomattox, Altavista, Forest, Rustburg, and Madison Heights.",
  howItWorksIntro: "Most Lynchburg travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Lynchburg travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lynchburg and Central Virginia Piedmont travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lynchburg? Here are the most common ones we hear from Central Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Lynchburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Lynchburg, VA",
      rating: 5,
      text: "I live near Liberty University and needed an emergency passport for a mission trip to Africa with 6 days notice. Fast Passport Center had my renewal in 4 days. I shipped from the UPS on Wards Road and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Forest, VA",
      rating: 5,
      text: "As a Forest resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Central Virginia families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Bedford, VA",
      rating: 5,
      text: "First passports for my two daughters before a family trip to Ireland. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Bedford County families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Lynchburg, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my business trip. Lynchburg professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "lynchburg-va-1",
      name: "Lynchburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Lynchburg",
      state: "VA",
      zip: "24501",
      phone: "(434) 845-7211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Lynchburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lynchburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "lynchburg-va-2",
      name: "Amherst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Amherst",
      state: "VA",
      zip: "24521",
      phone: "(434) 946-5191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Amherst, north of Lynchburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Amherst County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "lynchburg-va-3",
      name: "Bedford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Bedford",
      state: "VA",
      zip: "24523",
      phone: "(540) 586-7731",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bedford, west of Lynchburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bedford County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "lynchburg-va-4",
      name: "Appomattox Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Appomattox",
      state: "VA",
      zip: "24522",
      phone: "(434) 352-7451",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Appomattox, east of Lynchburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Appomattox County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "lynchburg-va-5",
      name: "Campbell County Clerk",
      type: "County Clerk",
      address: "PO Box 118",
      city: "Rustburg",
      state: "VA",
      zip: "24588",
      phone: "(434) 592-9517",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Rustburg, Campbell County",
      website: "https://www.co.campbell.va.us",
      websiteLabel: "Campbell County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "lynchburg-va-6",
      name: "Liberty University",
      type: "Campus Resource",
      address: "1971 University Blvd",
      city: "Lynchburg",
      state: "VA",
      zip: "24515",
      phone: "(434) 582-2000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Lynchburg, near Liberty University",
      website: "https://www.liberty.edu",
      websiteLabel: "Liberty University",
      notes: "Not a passport acceptance facility, but helpful for students and international program participants. Check with student services.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lynchburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Central Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lynchburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Lynchburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lynchburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lynchburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lynchburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lynchburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Lynchburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Central Virginia Piedmont." },
    { q: "How fast can I renew my passport in Lynchburg?", a: "Fast Passport Center offers fast passport renewal in Lynchburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Lynchburg?", a: "The nearest regional passport agency to Lynchburg is the Washington Passport Agency, located approximately 200 miles northeast in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Lynchburg." },
    { q: "Can I get a same-day passport appointment near Lynchburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Lynchburg residents." },
    { q: "Can I expedite a child passport in Lynchburg?", a: "Yes. Fast Passport Center expedites child passports in Lynchburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Lynchburg and Campbell County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lynchburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Lynchburg?", a: "With Fast Passport Center's emergency courier service, Lynchburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Lynchburg?", a: "Popular options include the Lynchburg Main Post Office (24501), Amherst Post Office (24521), Bedford Post Office (24523), and Appomattox Post Office (24522). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Forest, Madison Heights, or Bedford?", a: "We serve the entire Central Virginia Piedmont including Forest, Madison Heights, Bedford, Amherst, Appomattox, Altavista, and Rustburg. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Lynchburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Lynchburg", address: "3812 Wards Rd, Lynchburg, VA 24502", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Lynchburg", address: "2236 Wards Rd, Lynchburg, VA 24502", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Lynchburg", address: "2300 Wards Rd, Lynchburg, VA 24502", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Amherst", address: "167 S Main St, Amherst, VA 24521", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Bedford", address: "1148 E Lynchburg Salem Tpke, Bedford, VA 24523", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Forest", address: "17683 Forest Rd, Forest, VA 24551", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Lynchburg",
      address: "1600 Graves Mill Rd, Lynchburg, VA 24502",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Bedford",
      address: "1415 Wards Rd, Bedford, VA 24523",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Amherst",
      address: "124 Main St, Amherst, VA 24521",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Amherst County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LYH",
      name: "Lynchburg Regional Airport",
      distance: "Located within Lynchburg city limits",
      address: "350 Terminal Dr, Lynchburg, VA 24502",
      note: "The closest airport to Lynchburg. Domestic flights to major hubs. Accessible via US-29.",
      flightUrl: "https://www.flylyh.com/",
      flightLabel: "LYH Airport",
      featured: true,
    },
    {
      code: "ROA",
      name: "Roanoke-Blacksburg Regional Airport",
      distance: "Approximately 55 miles west of Lynchburg",
      address: "5202 Aviation Dr NW, Roanoke, VA 24012",
      note: "Regional hub for western Virginia. Accessible via US-460.",
      flightUrl: "https://www.flyroa.com/",
      flightLabel: "ROA Airport",
      featured: false,
    },
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "Approximately 65 miles north of Lynchburg",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "Regional hub for Central Virginia. Accessible via US-29.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 110 miles east of Lynchburg",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via US-360.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Lynchburg and Central Virginia residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Lynchburg Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.lynchburgva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Lynchburg Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.lynchburgva.gov/" },
  ],
};